import { render } from "./LocalSkillsChart.vue?vue&type=template&id=397ff9fd&scoped=true&ts=true"
import script from "./LocalSkillsChart.vue?vue&type=script&lang=ts"
export * from "./LocalSkillsChart.vue?vue&type=script&lang=ts"

import "./LocalSkillsChart.vue?vue&type=style&index=0&id=397ff9fd&scoped=true&lang=css"
import "./LocalSkillsChart.vue?vue&type=style&index=1&id=397ff9fd&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397ff9fd"]])

export default __exports__